import { isAdminRole } from "@seagames/contracts";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { moduleBySlug } from "../../components/reports/catalog";
import { ReportModulePage } from "../../components/reports/report-pages";

/** Central Report Engine › one module's reports. An unknown module, or an admin-only one for anyone else, goes back to the Overview. */
export const Route = createFileRoute("/_app/reports/$module")({
	beforeLoad: ({ context, params }) => {
		const m = moduleBySlug(params.module);
		if (!m || (m.adminOnly && !isAdminRole(context.session.active_role))) throw redirect({ to: "/reports" });
	},
	component: ReportModuleRoute,
});

function ReportModuleRoute() {
	const { session } = Route.useRouteContext();
	const { module } = Route.useParams();
	const m = moduleBySlug(module);
	return m ? <ReportModulePage key={m.key} session={session} module={m} /> : null;
}
